// Métadonnées visuelles des opérateurs de paiement (partagées checkout)
export const OPERATOR_META = {
    "orange-money": { label: "Orange Money", color: "#FF7900", bg: "bg-[#FF7900]/10" },
    wave: { label: "Wave", color: "#1DC7FA", bg: "bg-[#1DC7FA]/10" },
    mtn: { label: "MTN", color: "#FFCC00", bg: "bg-[#FFCC00]/15" },
    moov: { label: "Moov", color: "#0060A9", bg: "bg-[#0060A9]/10" },
    card: { label: "Carte", color: "#111", bg: "bg-secondary" },
};
